<template>
    <div class="materialBox">
        <div class="materialContent">
            <div class="materialTitle">
                <div class="materialTitleName">预览</div>
                <div class="materialTitleClose">
                    <img src="/static/images/closeIcon.png" alt="" @click="closePlayer">
                </div>
            </div>
            <div class="playMaterial">
                <!-- <iframe src="https://ow365.cn/?i=10622&n=3&fname=de102533b8494a80877871ada0392f2d.pptx&furl=_la@QeKQ1rt5zJ8l2GIJES3GHL7yQsNpCbx42NsbvPTnoyDWeJx1r6KMQ_G4vcW_pg2RaSaJ7EoACAT8Qtq6dzaJW9NLsH9vXnBzERoX@TE=" frameborder="0"></iframe> -->
                <iframe :src="src" frameborder="0"></iframe>
            </div>
        </div>
        
        
    </div>
</template>
<script>
import bus from '../../assets/eventBus/enentBus.js'
import statistic from '../../assets/statistics.js'
export default {
    name:'palyMaterial',
    data(){
        return{
            src:null,
            beginTime:null,
            overTime:null,
            statisticsData:null
        }
    },
    mounted(){
        const that = this;
        bus.$off('materialSrc');
        bus.$on('materialSrc',function(msg){
            console.log('试卷库',msg)
            that.src = msg.src;
            that.statisticsData = msg;
            that.beginTime = that.getTime();
        })
    },
    methods:{
        closePlayer(){
            this.$emit('closePlayer',false)
            this.src = null;
            this.overTime = this.getTime();
            let viewTime = this.overTime - this.beginTime;
            console.log(this.statisticsData)
            let data = this.statisticsData;
            if(this.statisticsData.type == 0){              //type:0   同步资源/区域优质资源
                statistic.statistics(data.id,data.name,data.soure,data.materialType,data.access,data.operateType,viewTime)
            }else if(this.statisticsData.type == 1){            //type：1    试卷库
                statistic.testPater(data.id,data.name,data.access,data.operateType,data.soure,viewTime)
            }
            
        },
        getTime(){
            let myDate = new Date();
            console.log(myDate.getTime())
            return myDate.getTime()
        }
    }
}
</script>
<style lang="">
    .materialBox{
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: rgba(0,0,0,.26);
        z-index: 99999;
    }
    .materialContent{
        width: 1200px;
        position: absolute;
        border-radius: 10px;
        background-color: #fff;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
    }
    .materialTitle{
        height: 40px;
        display: flex;
        flex-direction: row;
    }
    .materialTitleName{
        flex:5;
        line-height: 40px;
        font-size: 16px;
        text-align: left;
        padding-left: 20px;
    }
    .materialTitleClose{
        flex:1;
        display: table-cell;
        vertical-align: middle;
        text-align: right;
        padding-right: 20px;
        line-height: 40px;
    }
    .materialTitleClose img{
        width:16px;
        height: 16px;
        display: inline-block;
    }
    .materialTitleClose img:hover{
        cursor: pointer;
    }
    .playMaterial{
        background: #fff;
        border-radius: 10px;
    }
    .playMaterial iframe{
        width: 100%;
        height: 500px;
    }
</style>


// WEBPACK FOOTER //
// src/components/playMaterial/playMaterial.vue